import * as i0 from "@angular/core";
export class EquipmentMetadata {
}
EquipmentMetadata.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EquipmentMetadata_Factory() { return new EquipmentMetadata(); }, token: EquipmentMetadata, providedIn: "root" });
